module.exports = __webpack_public_path__ + "img/grin-stars.8d25c9a5.svg";